import React, { useState, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import {
  generateOTP,
  validateOTPAndSubmitForm,
  generateRedirectUrlWithUUID,
  encryptData,
} from '../../lib/otp-function';
import { useLocation } from 'react-router-dom';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import CountdownTimerSideMenu from '../Common/CountdownTimerSideMenu';
import { isMobile } from 'react-device-detect';
import {
  handleVerifyBtnEvent,
  handleLeadSuccessEvent,
  handleProductNavigationInteraction,
  handleLeadFormOtpCtaClick,
  handleLeadFormCtaClick,
} from '../../lib/customGA4';
import CryptoJS from 'crypto-js';

const StartJourneyForm = (props) => {
  const [oneverse, setOneverse] = useState(false);
  const [hasFlyer, setHasFlyer] = useState(false);
  const [hasDropdown, setHasDropdown] = useState(false);
  const [checkedOption, setCheckedOption] = useState('');
  const [activeTab, setActiveTab] = useState('');
  const [selectedPlan, setSelectedPlan] = useState('');
  const [position, setPosition] = useState();
  const [tabVisibility, setTabVisibility] = useState(true);

  const [redirectURL, setRedirectURL] = useState(
    props?.fields?.data?.tabs?.children[0]?.children[0]?.RedirectURL?.url
  );
  const [redirectProductCode, setRedirectProductCode] = useState(
    props?.fields?.data?.tabs?.children[0]?.children[0]?.RedirectProductCode?.value
  );
  const [redirectProductURL, setRedirectProductURL] = useState(
    props?.fields?.data?.tabs?.children[0]?.children[0]?.RedirectProductURL?.url
  );
  const [simpleRedirection, setSimpleRedirection] = useState(
    props?.fields?.data?.tabs?.children[0]?.children[0]?.SimpleRedirection?.value
  );

  const queryParams = useLocation().search;
  console.log('queryParams', queryParams);
  const params = new URLSearchParams(queryParams);

  const [redirecting, setRedirecting] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const timeoutRef = useRef();

  let buttonText = props?.i18n?.store?.data?.en?.translation || {};

  useEffect(() => {
    const modalElement = document.getElementById('get_in_touch_modal2');
    const handleModalShow = (event) => {
      setHasFlyer(event.relatedTarget?.getAttribute('data-usp') === 'true');
      setOneverse(event.relatedTarget?.getAttribute('data-oneverse') === 'true');
      setSelectedPlan(event.relatedTarget?.getAttribute('data-plan'));
      setHasDropdown(event.relatedTarget?.getAttribute('data-dropdown') === 'true');
      const isVisible = event.relatedTarget?.getAttribute('data-tab-display');
      setTabVisibility(isVisible === 'true' || isVisible === null);

      // setCheckedOption(
      //   event.relatedTarget?.getAttribute('data-accordion') ??
      //     props?.fields?.data?.tabs?.children[0]?.children[0]?.heading?.value
      // );
      setCheckedOption(
        props?.rendering?.params?.PageName?.split('|')[1] ??
          event.relatedTarget?.getAttribute('data-accordion') ??
          props?.fields?.data?.tabs?.children[0]?.children[0]?.heading?.value
      );
      // setActiveTab(
      //   (
      //     event.relatedTarget?.getAttribute('data-tab') ??
      //     props?.fields?.data?.tabs?.children[0]?.tabName?.value
      //   ).toLowerCase()
      // );
      setActiveTab(
        (
          props?.rendering?.params?.PageName?.split('|')[0] ??
          event.relatedTarget?.getAttribute('data-tab') ??
          props?.fields?.data?.tabs?.children[0]?.tabName?.value
        ).toLowerCase()
      );
      setPosition(event.relatedTarget?.getAttribute('data-position'));
      setRedirectURL(
        event.relatedTarget?.getAttribute('data-redirect-url') ??
          props?.fields?.data?.tabs?.children[0]?.children[0]?.RedirectURL?.url
      );
      setRedirectProductCode(
        event.relatedTarget?.getAttribute('data-redirect-product-code') ??
          props?.fields?.data?.tabs?.children[0]?.children[0]?.RedirectProductCode?.value
      );
      setRedirectProductURL(
        event.relatedTarget?.getAttribute('data-redirect-product-url') ??
          props?.fields?.data?.tabs?.children[0]?.children[0]?.RedirectProductURL?.url
      );
      setSimpleRedirection(
        event.relatedTarget?.getAttribute('data-simple-redirection') ??
          props?.fields?.data?.tabs?.children[0]?.children[0]?.SimpleRedirection?.value
      );
    };

    modalElement.addEventListener('show.bs.modal', handleModalShow);

    return () => {
      modalElement.removeEventListener('show.bs.modal', handleModalShow);
    };
  }, [props]);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [plans, setPlans] = useState([]);
  const [lob, setLob] = useState('');
  const [planDropdownClass, setPlanDropdownClass] = useState('');
  const [planDropdowns, setPlanDropdowns] = useState([]);
  const [agreed, setAgreed] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [isMobileNumerVerified, setIsMobileNumerVerified] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [phoneErrorVisible, setPhoneErrorVisible] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpValidationFailed, setOtpValidationFailed] = useState(false);
  const [otpSuccess, setOtpSuccess] = useState(false);
  const [otpMessage, setOtpMessage] = useState('');
  const [otpValue, setOtpValue] = useState(['', '', '', '', '', '']);
  const [currentStep, setCurrentStep] = useState(1);
  const [formClasses, setFormClasses] = useState({
    form1: 'form-active',
    form2: '',
    form3: '',
  });
  const [responseCode, setResponseCode] = useState();
  const [submittingForm, setSubmittingForm] = useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    handleProductNavigationInteraction(tab, 'card');
  };

  const handleCheckboxChange = (option) => {
    setCheckedOption(option);

    const selectedItem = props?.fields?.data?.tabs?.children
      ?.flatMap((item) => item?.children)
      ?.find((child) => child?.heading?.value === option);

    if (selectedItem) {
      setRedirectURL(selectedItem.RedirectURL?.url || '');
      setRedirectProductCode(selectedItem.RedirectProductCode?.value || '');
      setRedirectProductURL(selectedItem.RedirectProductURL?.url || '');
      setSimpleRedirection(selectedItem.SimpleRedirection?.value || '');
    }
  };

  const [flyers, setFlyers] = useState([]);
  const [recommendedProducts, setRecommendedProducts] = useState([]);

  const tabItem = props?.fields?.data?.tabs?.children?.find((item) =>
    item?.children?.some((child) => child?.heading?.value === checkedOption)
  );

  const [productName, setProductName] = useState(
    tabItem
      ? tabItem?.children?.find((child) => child?.heading?.value === checkedOption)?.ProductName
          ?.value || ''
      : ''
  );
  const [productCategory, setProductCategory] = useState(
    tabItem
      ? tabItem?.children?.find((child) => child?.heading?.value === checkedOption)?.ProductCategory
          ?.value || ''
      : ''
  );

  useEffect(() => {
    const tabItem = props?.fields?.data?.tabs?.children?.find((item) =>
      item?.children?.some((child) => child?.heading?.value === checkedOption)
    );

    setFlyers(
      tabItem
        ? tabItem?.children?.find((child) => child?.heading?.value === checkedOption)?.flyers
            .targetItems || []
        : []
    );

    setRecommendedProducts(
      tabItem
        ? tabItem?.children?.find((child) => child?.heading?.value === checkedOption)
            ?.recommendedForYou.targetItems || []
        : []
    );

    setPlans(
      tabItem
        ? tabItem?.children?.find((child) => child?.heading?.value === checkedOption)?.products ||
            []
        : []
    );

    setLob(
      tabItem
        ? tabItem?.children?.find((child) => child?.heading?.value === checkedOption)?.LOB
            ?.targetItem?.Key?.value || ''
        : ''
    );

    setProductName(
      tabItem
        ? tabItem?.children?.find((child) => child?.heading?.value === checkedOption)?.ProductName
            ?.value || ''
        : ''
    );

    setProductCategory(
      tabItem
        ? tabItem?.children?.find((child) => child?.heading?.value === checkedOption)
            ?.ProductCategory?.value || ''
        : ''
    );

    new Swiper('.git-mySwiper', {
      slidesPerView: 2.9,
      centeredSlides: !1,
      spaceBetween: 10,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2.3,
          spaceBetween: 10,
        },
        1536: {
          slidesPerView: 2.5,
          spaceBetween: 10,
        },
      },
    });
  }, [props, checkedOption, planDropdowns]);

  const renderTabs = () => {
    return props?.fields?.data?.tabs?.children?.map((tab, index) => (
      <li key={index} className="nav-item" role="presentation">
        <button
          className={`nav-link ${activeTab === tab?.tabName?.value?.toLowerCase() ? 'active' : ''}`}
          onClick={() => handleTabClick(tab?.tabName?.value?.toLowerCase())}
          type="button"
          role="tab"
          aria-controls={`checkbox_pills-${tab?.tabName?.value?.toLowerCase()}`}
          aria-selected={activeTab === tab?.tabName?.value?.toLowerCase()}
        >
          {tab.tabName.value}
        </button>
      </li>
    ));
  };

  const renderTabContent = () => {
    return props?.fields?.data?.tabs?.children?.map((tab, index) => (
      <div
        key={index}
        className={`tab-pane fade ${
          activeTab === tab?.tabName?.value?.toLowerCase() ? 'show active' : ''
        }`}
        id={`checkbox_pills-${tab?.tabName?.value?.toLowerCase()}`}
        role="tabpanel"
        aria-labelledby={`checkBox-${tab?.tabName?.value?.toLowerCase()}-tab`}
      >
        <div className="check-box-flex git-check-box-flex">
          {tab?.children?.map((secondaryItem) => (
            <div key={secondaryItem.heading.value} className="check-box-box check-box-filter2">
              <input
                id={`checkBoxEn${secondaryItem.heading.value}`}
                name="check-group"
                type="checkbox"
                value="yes"
                checked={checkedOption === secondaryItem.heading.value}
                onChange={() => handleCheckboxChange(secondaryItem.heading.value)}
              />
              <label htmlFor={`checkBoxEn${secondaryItem.heading.value}`} className="plan_details">
                <span className="label-icon-w">
                  <img
                    src={secondaryItem.leftIcon.src}
                    alt={secondaryItem.heading.value}
                    loading="lazy"
                  />
                </span>
                <span className="label-title-w">{secondaryItem.heading.value}</span>
              </label>
            </div>
          ))}
        </div>
      </div>
    ));
  };

  useEffect(() => {
    const tabData = props?.fields?.data?.tabs?.children
      ?.flatMap((tab) => tab.children)
      ?.map(
        ({
          heading,
          RedirectURL,
          RedirectProductCode,
          RedirectProductURL,
          SimpleRedirection,
          products,
        }) => ({
          heading,
          RedirectURL,
          RedirectProductCode,
          RedirectProductURL,
          SimpleRedirection,
          products:
            products?.map(
              ({ RedirectURL, RedirectProductCode, RedirectProductURL, SimpleRedirection }) => ({
                RedirectURL,
                RedirectProductCode,
                RedirectProductURL,
                SimpleRedirection,
              })
            ) || [],
        })
      );

    const match = tabData?.find((item) => item.heading.value === checkedOption);

    if (match) {
      setRedirectURL(match.RedirectURL?.url || '');
      setRedirectProductCode(match.RedirectProductCode?.value || '');
      setRedirectProductURL(match.RedirectProductURL?.url || '');
      setSimpleRedirection(match.SimpleRedirection?.value || '');
    } else {
      const fallback = tabData?.[0] || {};
      setRedirectURL(fallback.RedirectURL?.url || '');
      setRedirectProductCode(fallback.RedirectProductCode?.value || '');
      setRedirectProductURL(fallback.RedirectProductURL?.url || '');
      setSimpleRedirection(fallback.SimpleRedirection?.value || '');
    }
  }, [props, checkedOption]);

  const countdownTimerRef = useRef();

  const handleNameChange = (e) => {
    const enteredValue = e.target.value;
    const isValidName = /^[A-Za-z\s]{0,50}$/.test(enteredValue);

    if (isValidName) {
      setName(enteredValue);
    }

    updateVerificationStatus();
  };

  const handleKeyPress = (event) => {
    const isValidInput =
      /^[\d\s()-]*$/.test(event.key) || event.key === 'Backspace' || event.key === 'Delete';
    if (!isValidInput) {
      event.preventDefault();
    }
  };

  const handleMobileNumberChange = (e) => {
    const enteredValue = e.target.value;
    const isValidMobileNumber =
      /^[6-9][0-9]{0,9}$/.test(enteredValue.replace(/\D/g, '')) && !/(.)\1{6,}/.test(enteredValue);

    if (isValidMobileNumber || enteredValue === '') {
      setMobileNumber(enteredValue.replace(/\D/g, ''));
      setPhoneErrorVisible(false);
      setIsMobileNumerVerified(true);
      updateVerificationStatus();
    } else {
      setPhoneErrorVisible(true);
      setIsMobileNumerVerified(false);
    }
  };

  const updateVerificationStatus = () => {
    if (
      name.trim() !== '' &&
      mobileNumber.trim() !== '' &&
      mobileNumber.length === 10 &&
      (formSubmitted ? isMobileNumerVerified : true) &&
      agreed
    ) {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  };

  useEffect(() => {
    updateVerificationStatus();
  }, [name, mobileNumber, isMobileNumerVerified, agreed]);

  useEffect(() => {
    setFormClasses((prevClasses) => ({
      ...prevClasses,
      [`form${currentStep}`]: 'form-active form-active-animate',
    }));

    setTimeout(() => {
      setFormClasses((prevClasses) => ({
        ...prevClasses,
        [`form${currentStep - 1}`]: '',
      }));
    }, 1000);
  }, [currentStep]);

  const gotoNextForm = (stepPrev, stepNext) => {
    setCurrentStep(stepNext);
  };
  const inputs = useRef([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!/^\d{10}$/.test(mobileNumber)) {
      setPhoneErrorVisible(true);
      return;
    }

    handleLeadFormOtpCtaClick(
      props?.fields?.data?.start_journey?.ContentPath?.form_data?.GetOtpButton?.value
        ? props?.fields?.data?.start_journey?.ContentPath?.form_data?.GetOtpButton?.value
        : props?.t('SendOTP'),
      activeTab,
      checkedOption,
      position
    );

    generateOTP(mobileNumber, setOtpMessage, setOtpSent, setOtpSuccess);
    gotoNextForm(1, 2);
    setResponseCode();
  };

  const handleChange = (index, value) => {
    if (isNaN(value)) return;

    const updatedOtpValue = [...otpValue];
    updatedOtpValue[index] = value;

    setOtpValue(updatedOtpValue);

    if (value !== '' && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const resendCode = () => {
    handleLeadFormCtaClick(buttonText?.ResendOtp, activeTab, checkedOption, position);
    countdownTimerRef.current.reset();
    generateOTP(mobileNumber, setOtpMessage, setOtpSent, setOtpSuccess);
  };

  const changeNumber = () => {
    handleLeadFormCtaClick(props.t('ChangeNumber'), activeTab, checkedOption, position);
    gotoNextForm(2, 1);
    setOtpValue(['', '', '', '', '', '']);
    setResponseCode();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text/plain').slice(0, 6);

    for (let i = 0; i < pasteData.length; i++) {
      handleChange(i, pasteData[i]);
    }
  };

  const isOtpFilled = () => {
    return otpValue.every((value) => value !== '');
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && index > 0 && otpValue[index] === '') {
      inputs.current[index - 1].focus();
    }
  };
  const queryparameters = {
    UtmADGroup: params.get('UtmADGroup') || '',
    UtmADID: params.get('UtmADID') || '',
    UtmCampaign: params.get('UtmCampaign') || '',
    UtmContent: params.get('UtmContent') || '',
    UtmId: params.get('UtmId') || '',
    UtmMedium: params.get('UtmMedium') || '',
    UtmSource: params.get('UtmSource') || '',
    UtmTerm: params.get('UtmTerm') || '',
  };

  const formType =
    props?.fields?.data?.start_journey?.ContentPath?.form_data?.FormType?.targetItem?.Key?.value;

  const apiParameters = {
    Source:
      props?.fields?.data?.start_journey?.ContentPath?.form_data?.Source?.targetItem?.Key?.value ||
      '',
    SubSource:
      props?.fields?.data?.start_journey?.ContentPath?.form_data?.SubSource?.targetItem?.Key
        ?.value || '',
    CurrentSubSource:
      props?.fields?.data?.start_journey?.ContentPath?.form_data?.CurrentSubSource?.value || '',
    LOB: lob || '',

    TypeOfBusiness:
      props?.fields?.data?.start_journey?.ContentPath?.form_data?.TypeOfBusiness?.targetItem?.Key
        ?.value,
    ProductName: productName || '',
    ProductCategory: productCategory || '',
    FormType:
      props?.fields?.data?.start_journey?.ContentPath?.form_data?.FormType?.targetItem?.Key
        ?.value || '',
    DeviceType: isMobile ? 'Mobile' : 'Desktop',
  };

  const validateAndSubmit = async (e, buttonText) => {
    e.preventDefault();
    if (submittingForm) {
      return;
    }
    setSubmittingForm(true);
    const otp = otpValue.join('');

    const formData = {
      otp: otp,
      mobileNumber: mobileNumber,
      name: name,
      email: email,
      agreed: agreed,
      apiParameters: apiParameters,
      queryparameters: queryparameters,
      pageUrl: window.location.href,
    };

    const encryptedFormData = encryptData(
      JSON.stringify(formData),
      props?.t('SecretKey'),
      props?.t('SecretKeyIV')
    );
    const formSubmitResponse = await validateOTPAndSubmitForm(encryptedFormData);

    setSubmittingForm(false);
    setResponseCode(formSubmitResponse?.ReturnCode);
    if (
      formSubmitResponse?.compositeResponse[0]?.httpStatusCode === 200 ||
      formSubmitResponse?.compositeResponse[0]?.httpStatusCode === 201 ||
      formSubmitResponse?.compositeResponse[0]?.httpStatusCode === 400
    ) {
      const redirectUrlfrom =
        props?.fields?.data?.start_journey?.ContentPath?.form_data?.RedirectURL?.value?.url;
      const simpleRedirectionForm =
        props?.fields?.data?.start_journey?.ContentPath?.form_data?.SimpleRedirection?.value;

      const leadId = formSubmitResponse?.compositeResponse[0]?.body[0]?.message
        ?.split(':')[1]
        ?.trim();

      const successLeadId = formSubmitResponse?.compositeResponse[0]?.body?.id;

      const source = window.location.href.split('/').filter(Boolean).pop();
      const channel = 'web';
      const url = window?.location?.href;

      handleVerifyBtnEvent(buttonText, activeTab, checkedOption, position);
      if (redirectProductURL && !simpleRedirection) {
        generateRedirectUrl(
          redirectURL,
          successLeadId ? successLeadId : leadId,
          simpleRedirection,
          redirectProductURL,
          source,
          channel,
          url
        );
      } else if (redirectURL && !simpleRedirection) {
        generateRedirectUrl(
          redirectURL,
          successLeadId ? successLeadId : leadId,
          simpleRedirection,
          new URL(redirectURL).origin,
          source,
          channel,
          url
        );
      } else if (redirectURL && simpleRedirection) {
        window.location.href = redirectURL;
      } else if (redirectUrlfrom && !simpleRedirectionForm) {
        generateRedirectUrl(
          redirectUrlfrom,
          successLeadId ? successLeadId : leadId,
          simpleRedirection,
          new URL(redirectUrlfrom).origin,
          source,
          channel,
          url
        );
      } else if (redirectUrlfrom && simpleRedirectionForm) {
        window.location.href = redirectUrlfrom;
      } else {
        gotoNextForm(2, 3);
      }
      handleLeadSuccessEvent(
        buttonText,
        activeTab,
        checkedOption,
        position,
        formSubmitResponse?.compositeResponse[0].body?.id
      );
      setOtpSent(true);
      setOtpValidationFailed(false);
    } else if (formSubmitResponse?.ReturnCode === '-1') {
      setResponseCode(formSubmitResponse?.ReturnCode);
    } else if (formSubmitResponse?.ReturnCode === '0') {
      setResponseCode(formSubmitResponse?.ReturnCode);
    } else {
      setOtpSent(false);
      setOtpValidationFailed(true);
    }
  };

  useEffect(() => {
    if (!props?.fields?.data?.start_journey?.ContentPath?.form_data?.RedirectURL?.url) return;

    if (redirecting && countdown > 0) {
      timeoutRef.current = setTimeout(() => {
        setCountdown((prevCount) => prevCount - 1);
      }, 1000);

      return () => clearTimeout(timeoutRef.current);
    } else if (redirecting && countdown === 0) {
      const url = generateRedirectUrl();
      window.location.href = url;
    }
  }, [redirecting, countdown, props]);

  const handleStay = () => {
    setRedirecting(false);
    clearTimeout(timeoutRef.current);
  };

  const generateRedirectUrl = async (
    url,
    id,
    simpleRedirection,
    redirectURL,
    source,
    channel,
    pageurl
  ) => {
    try {
      if (simpleRedirection !== true) {
        const dynamicObject = {
          mobileNumber: encodeURIComponent(mobileNumber),
          username: encodeURIComponent(name),
          productId: encodeURIComponent(redirectProductCode),
          lmsId: encodeURIComponent(id),
          source,
          channel,
          url: pageurl,
        };

        const encryptedObject = encryptData(
          JSON.stringify(dynamicObject),
          props?.t('SecretKey'),
          props?.t('SecretKeyIV')
        );
        const response = await generateRedirectUrlWithUUID(
          url,
          mobileNumber,
          encryptedObject,
          source,
          channel
        );
        if (response) {
          window.location.href = `${new URL(redirectURL)}?${props.t('query_param_uuid')}=${
            response?.uuid
          }`;
        }
      } else {
        window.location.href = url;
      }
    } catch (error) {
      console.error('Error generating redirect URL with UUID:', error);
    }
  };

  useEffect(() => {
    if (currentStep === 3) {
      setRedirecting(true);
    }
  }, [currentStep]);

  return (
    <div
      className="modal fade right_pos right_pos_modal-enquiry enquire-now-modal-xl right-transY-modal startYourJourney_xForm"
      id="get_in_touch_modal2"
      tabIndex={-1}
      aria-labelledby="get_in_touch_modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-slideout-right">
        <div className="modal-content">
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          {}
          <div className="modal-body modal-body-git">
            <div className="enquire-now-stepper">
              <div className="start_journey_form_wrapper formJourney-xm ">
                <div className="to-help-form-area">
                  <div className="to-help-div">
                    <div className="to-help-stepper-form-mb">
                      <div className="stepper">
                        <div className="step--1 step-active">Step 1</div>
                        <div className="step--2">Step 2</div>
                        <div className="step--31">Step 3</div>
                        <div className="step--4">Finish</div>
                      </div>
                      <div className="form-parent">
                        {}
                        {currentStep === 1 && (
                          <form id="stepper-form-1-step-hf" className={`form ${formClasses.form1}`}>
                            <div className="form-input-main top-overlap">
                              <input type="hidden" id="lob" value={lob} />
                              <input type="hidden" id="formType" value={formType} />
                              <div className="input-field fieldset checkboxes-menus">
                                <div className="start_journey_head_Wrapper left_heading_wrap">
                                  <RichText
                                    tag="div"
                                    className="jounrneyStepHeading"
                                    field={
                                      props?.fields.data?.start_journey?.ContentPath?.form_data
                                        ?.Heading
                                    }
                                    editable
                                  />
                                  <p>
                                    <Text
                                      field={
                                        props?.fields.data?.start_journey?.ContentPath?.form_data
                                          ?.SubHeading
                                      }
                                      editable
                                    />
                                  </p>
                                </div>
                                {tabVisibility && (
                                  <>
                                    <div className="magic_line_tabs_filter_faq">
                                      <ul
                                        className="faq_tab_Wrapper magic_line_faq_menu"
                                        id="checkBox_pills-tab"
                                        role="tablist"
                                      >
                                        {renderTabs()}
                                        <div className="magic-line_faq" />
                                      </ul>
                                    </div>
                                    <div
                                      className="tab-content faq_Wrapper_tab_div"
                                      id="formCheckbox-container"
                                    >
                                      {renderTabContent()}
                                    </div>
                                  </>
                                )}
                              </div>
                              {hasFlyer && (
                                <div className="per-offer-asper">
                                  <RichText
                                    tag="p"
                                    className="offerptag"
                                    field={flyers[0]?.text}
                                    editable
                                  />
                                </div>
                              )}
                              {hasDropdown && (
                                <div className="input-field fieldset select-set mt-2">
                                  <div
                                    className={`dropdown ${planDropdownClass}`}
                                    onClick={() => {
                                      if (planDropdownClass.length === 0) {
                                        setPlanDropdownClass('dropdown__options--visible');
                                      } else {
                                        setPlanDropdownClass('');
                                      }
                                    }}
                                  >
                                    <div className="dropdown__skeleton">
                                      <div className="dropdown__selected dropdown__option">
                                        <span>{selectedPlan}</span>
                                      </div>
                                      <div className="dropdown__arrow"></div>
                                    </div>
                                    <div className={`dropdown__options ${planDropdownClass}`}>
                                      {plans?.map(
                                        (plan) =>
                                          plan?.productName?.value !== 'Select Plan' &&
                                          plan?.productName?.value !== selectedPlan && (
                                            <div
                                              key={plan?.Key?.value}
                                              className="dropdown__option"
                                              onClick={() => {
                                                setSelectedPlan(plan?.productName?.value);
                                                setPlanDropdownClass('');
                                              }}
                                            >
                                              <span>{plan?.productName?.value}</span>
                                            </div>
                                          )
                                      )}
                                    </div>
                                  </div>
                                  {selectedPlan !== 'Select Plan' && (
                                    <div className="drop-paragraph">
                                      {planDropdowns?.map((item, index) => {
                                        return (
                                          <RichText
                                            key={index}
                                            tag="p"
                                            className={`ptag-text optionp${index + 2}`}
                                            field={item?.Text}
                                          />
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                              )}
                              <div className="input-field fieldset name-field mail-result-group">
                                <div className="input-inner">
                                  <label className="label-otp-input" htmlFor="name">
                                    {props?.t('FullName')}
                                  </label>
                                  <input
                                    className="otp-inputs"
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={name}
                                    onChange={handleNameChange}
                                    required
                                    placeholder={props?.t('EnterName')}
                                  />
                                </div>
                              </div>
                              <div className="input-field fieldset number-field mail-result-group">
                                <div className="input-inner">
                                  <label className="label-otp-input" htmlFor="name">
                                    {props?.t('ContactNumber')}
                                  </label>
                                  <div className="mob_number_input_i">
                                    <span className="country_code_n">
                                      {props?.t('CountryCode')}
                                    </span>
                                    <input
                                      type="text"
                                      className="otp-inputs counntry-before"
                                      name="mobileNumber"
                                      value={mobileNumber}
                                      onChange={handleMobileNumberChange}
                                      onKeyPress={handleKeyPress}
                                      required
                                      maxLength="10"
                                      placeholder={props?.t('EnterPhone')}
                                    />
                                  </div>
                                </div>
                              </div>
                              {phoneErrorVisible && (
                                <div
                                  id="phoneError"
                                  style={{
                                    color: 'red',
                                    textAlign: 'center',
                                    margin: '-35px 0 15px 0',
                                  }}
                                >
                                  {props?.t('InvalidPhone')}
                                </div>
                              )}
                              {oneverse && (
                                <div className="input-field fieldset checkbox-field">
                                  <div className="input-inner">
                                    <div className="tacbox">
                                      <input
                                        id="wp-comment-cookies-consent "
                                        name="wp-comment-cookies-consent"
                                        required
                                        type="checkbox"
                                        checked={agreed}
                                        onChange={(e) => setAgreed(e.target.checked)}
                                      />
                                      <label htmlFor="wp-comment-cookies-consent">
                                        {props?.t('AgreeText')}{' '}
                                        <a
                                          href={
                                            props?.fields.data?.start_journey?.ContentPath
                                              ?.form_data?.TermsnCondition?.url
                                          }
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          {props?.t('TermnCondition')}
                                        </a>
                                        .
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className="btn-field">
                                <input
                                  className={`form__btn stepper-btn-style send-otp ${
                                    isVerified ? 'verified' : ''
                                  } btn-next3 form__btn git-form__btn form_btn_small`}
                                  id="btn-next3"
                                  type="submit"
                                  disabled={!isVerified}
                                  value={
                                    props?.fields?.data?.start_journey?.ContentPath?.form_data
                                      ?.GetOtpButton?.value
                                      ? props?.fields?.data?.start_journey?.ContentPath?.form_data
                                          ?.GetOtpButton?.value
                                      : props?.t('SendOTP')
                                  }
                                  onClick={handleSubmit}
                                />
                              </div>
                            </div>
                          </form>
                        )}
                        {}
                        {currentStep === 2 && (
                          <form
                            className={`form ${formClasses.form2}`}
                            id="journey_stepper_form_enqnow-hf"
                            onSubmit={validateAndSubmit}
                          >
                            <div className="otp-vcarification-step height-100 d-flex justify-content-center align-items-center">
                              <div className="position-relative">
                                <div className="card p-2 text-center">
                                  <div className="jounrneyStepHeading">
                                    {props?.t('OTPVerification')}
                                  </div>
                                  <p className="otp-para">
                                    {
                                      props?.i18n?.store?.data?.en?.translation
                                        ?.OTPVerificationMessage
                                    }
                                  </p>
                                  <p className="otp-number">
                                    {props?.t('CountryCode')}-{mobileNumber}{' '}
                                    <span
                                      className="change-number"
                                      style={{ cursor: 'pointer' }}
                                      onClick={changeNumber}
                                    >
                                      {props?.t('ChangeNumber')}
                                    </span>
                                  </p>
                                  <p className="resend-otp">
                                    {}
                                    <span id="countdowntimer" className="span-strong">
                                      <CountdownTimerSideMenu
                                        ref={countdownTimerRef}
                                        resendCode={resendCode}
                                        buttonText={buttonText}
                                      />
                                    </span>
                                  </p>
                                  <div
                                    id="otp"
                                    className="otpInputs inputs d-flex flex-row justify-content-center mt-2"
                                    onPaste={handlePaste}
                                  >
                                    {Array.from({ length: 6 }, (_, index) => (
                                      <input
                                        key={index}
                                        ref={(el) => (inputs.current[index] = el)}
                                        required
                                        className="m-2 text-center form-control rounded"
                                        type="text"
                                        maxLength="1"
                                        value={otpValue[index]}
                                        onChange={(e) => handleChange(index, e.target.value)}
                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                      />
                                    ))}
                                  </div>
                                  {responseCode === '0' && (
                                    <span id="phoneError" style={{ color: 'red' }}>
                                      {props.t('OTPServiceError')}
                                    </span>
                                  )}
                                  {responseCode === '-1' && (
                                    <span id="phoneError" style={{ color: 'red' }}>
                                      {props.t('InvalidOTP')}
                                    </span>
                                  )}
                                  {responseCode === '400' && (
                                    <span id="phoneError" style={{ color: 'red' }}>
                                      {props.t('LMServiceError')}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <input
                              style={{ background: isOtpFilled() ? '#C91429' : 'darkgray' }}
                              className="form__btn stepper-btn-style center verify-btn-us"
                              id="verifyBtn"
                              type="submit"
                              value={
                                submittingForm
                                  ? props?.fields?.data?.start_journey?.ContentPath?.form_data
                                      ?.VerifyingOtpButton?.value
                                    ? props?.fields?.data?.start_journey?.ContentPath?.form_data
                                        ?.VerifyingOtpButton?.value
                                    : props.t('Verifying')
                                  : props?.fields?.data?.start_journey?.ContentPath?.form_data
                                      ?.VerifyOtpButton?.value
                                  ? props?.fields?.data?.start_journey?.ContentPath?.form_data
                                      ?.VerifyOtpButton?.value
                                  : props?.t('VerifyOTP')
                              }
                              onClick={(e) =>
                                validateAndSubmit(
                                  e,
                                  props?.fields?.data?.start_journey?.ContentPath?.form_data
                                    ?.VerifyOtpButton?.value
                                    ? props?.fields?.data?.start_journey?.ContentPath?.form_data
                                        ?.VerifyOtpButton?.value
                                    : props?.t('VerifyOTP')
                                )
                              }
                              disabled={submittingForm}
                            />
                          </form>
                        )}
                        {currentStep === 3 && (
                          <form id="stepper-form-1-step-3" className={`form ${formClasses.form3}`}>
                            <div className="stepper-heaiding-mb thankYou-banner-form">
                              <div className="heading-inner">
                                <div className="verified-icon">
                                  <Image
                                    field={
                                      props?.fields?.data?.start_journey?.ContentPath?.form_data
                                        ?.ThankYouIcon
                                    }
                                    loading="lazy"
                                  />
                                </div>
                                <div className="jounrneyStepHeading">
                                  {props?.fields?.data?.start_journey?.ContentPath?.form_data
                                    ?.ThankYouMessage?.value
                                    ? props?.fields?.data?.start_journey?.ContentPath?.form_data
                                        ?.ThankYouMessage?.value
                                    : props.t('ThankMessage1')}
                                </div>
                                <p className="stepper-paragraph">
                                  {props?.fields?.data?.start_journey?.ContentPath?.form_data
                                    ?.ThankYouMessageSub?.value
                                    ? props?.fields?.data?.start_journey?.ContentPath?.form_data
                                        ?.ThankYouMessageSub?.value
                                    : props.t('ThankMessage2')}
                                </p>
                              </div>
                            </div>
                            {redirecting &&
                              props?.fields?.data?.start_journey?.ContentPath?.form_data
                                ?.RedirectURL?.url && (
                                <div className="redirect-message mt-3">
                                  <p className="stepper-paragraph">
                                    {props?.t('Redirecting')} {countdown} {props?.t('Seconds')}
                                  </p>
                                  {}
                                </div>
                              )}
                            <div className="metavrese-recco-cards">
                              <div className="metaReco-heaading">
                                <div className="meta-heading-6">
                                  {props?.t('RecommendedForYou')}
                                </div>
                              </div>
                              <div className="git-recco-slider">
                                <div className="swiper git-mySwiper">
                                  <div className="swiper-wrapper">
                                    {recommendedProducts?.map((item, index) => {
                                      return (
                                        <div key={index} className="swiper-slide">
                                          <div className="recom-slide">
                                            <div className="rfy-item">
                                              <div className="icon-rfy">
                                                <img
                                                  src={item?.icon?.src}
                                                  width={50}
                                                  height={50}
                                                  loading="lazy"
                                                />
                                              </div>
                                              <div className="content-rfy">
                                                <span className="red-span-metavrs">
                                                  {item?.productType?.value}
                                                </span>
                                                <p>{item?.productName?.value}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <a
                              className="form__btn stepper-btn-style center verify-btn verified"
                              id="en_stepper_complete-hf"
                              href={
                                props?.fields.data?.start_journey?.ContentPath?.form_data
                                  ?.ThankYouCTA?.url
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              {props?.t('ExploreProducts')}
                            </a>
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(StartJourneyForm);
